export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 3,
    "title": "What is the function of data systems?",
    "description": "The capability to store, process, and analyze data efficiently and effectively."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What are data systems professionals responsible for?",
    "description": "Examining business needs, selecting data tools, designing, deploying, monitoring, managing, and securely maintaining database systems, and ensuring data security and availability."
  },
  {
    "id": 3,
    "topic_id": 2,
    "title": "What are the three pillars that allow data analytics to thrive?",
    "description": "Massive volumes of daily generated data, cost-effective storage, and expandable computing power."
  },
  {
    "id": 4,
    "topic_id": 5,
    "title": "What does Moore\u2019s law translate to for computing technology?",
    "description": "The number of transistors on a single device will double every two years."
  },
  {
    "id": 5,
    "topic_id": 3,
    "title": "How do relational databases organize data?",
    "description": "Relational databases use related tables of information to organize data."
  },
  {
    "id": 6,
    "topic_id": 4,
    "title": "How do nonrelational databases, such as NoSQL types, organize data?",
    "description": "NoSQL-type data is organized as document databases, key-value stores, column-oriented databases, and graph databases instead of using related tables."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "What are the two major sublanguages of Structured Query Language (SQL)?",
    "description": "Data Definition Language (DDL) and Data Manipulation Language (DML)."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "What is the function of Data Definition Language (DDL)?",
    "description": "DDL is used to define and alter the structure of databases."
  },
  {
    "id": 9,
    "topic_id": 2,
    "title": "What is the function of Data Manipulation Language (DML)?",
    "description": "DML is used to insert, update, delete, and retrieve data from a database."
  },
  {
    "id": 10,
    "topic_id": 4,
    "title": "What is done during requirements gathering?",
    "description": "Collecting information from stakeholders to determine the basic parameters of the data system."
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "What database feature speeds up common queries?",
    "description": "Indexes."
  },
  {
    "id": 12,
    "topic_id": 4,
    "title": "What technical and administrative tools are used to obscure sensitive data elements?",
    "description": "Encryption and data masking."
  },
  {
    "id": 13,
    "topic_id": 5,
    "title": "What is the function of business continuity activities?",
    "description": "Business continuity activities are designed to keep a business running in the face of natural and man-made incidents."
  },
  {
    "id": 14,
    "topic_id": 2,
    "title": "What is the function of disaster recovery activities?",
    "description": "Disaster recovery is a subset of business continuity activities and is designed to promptly restore a business back to normal operations following a disruption."
  },
  {
    "id": 15,
    "topic_id": 4,
    "title": "What are three technical mechanisms used to achieve business continuity and disaster recovery?",
    "description": "The use of database backups, database replication, and high availability controls to protect database systems."
  },
  {
    "id": 16,
    "topic_id": 4,
    "title": "In relational databases, what provides the structure for storing data?",
    "description": "Relations/tables."
  },
  {
    "id": 17,
    "topic_id": 2,
    "title": "In relational databases, what is the function of tables?",
    "description": "Tables contain collections of attributes about data subjects."
  },
  {
    "id": 18,
    "topic_id": 5,
    "title": "In a relational database, what is an attribute?",
    "description": "An attribute is an individual characteristic stored as a column in a table."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What is the term for specific pieces of data about a single data subject?",
    "description": "Tuple/row."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "What is the term for the attribute that uniquely identifies a row in relational databases?",
    "description": "Primary key."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "In relational databases, what is the term that describes creating a link between two tables by adding an attribute to one table that references the primary key of another table?",
    "description": "Foreign key."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "What are three considerations when selecting a database management system?",
    "description": "Licensing model, scaling, and hosting needs."
  },
  {
    "id": 23,
    "topic_id": 1,
    "title": "What is SQL?",
    "description": "Structured Query Language (SQL) is a query language that allows defining of objects and manipulating of data in relational databases, including storing, retrieving, and analyzing data."
  },
  {
    "id": 24,
    "topic_id": 1,
    "title": "What is a nonrelational database?",
    "description": "A highly flexible data organization and storage approach that doesn\u2019t conform to the tabular structure of relational databases."
  },
  {
    "id": 25,
    "topic_id": 1,
    "title": "What is the term used to describe nonrelational databases?",
    "description": "NoSQL database."
  },
  {
    "id": 26,
    "topic_id": 1,
    "title": "What is a key in a key-value database?",
    "description": "A key is a globally unique index made up of a sequence of numbers or a string that points to an associated value."
  },
  {
    "id": 27,
    "topic_id": 1,
    "title": "What is an important advantage to using a document database?",
    "description": "A document database allows for search of the contents of documents because it understands document structure."
  },
  {
    "id": 28,
    "topic_id": 1,
    "title": "What is the term for a lightweight structured text-based data interchange format?",
    "description": "JSON (JavaScript Object Notation)."
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "What does a column-oriented database use to identify data in groups of related columns?",
    "description": "An index."
  },
  {
    "id": 30,
    "topic_id": 1,
    "title": "Which database design is used by data warehousing and business intelligence applications?",
    "description": "They use column-oriented databases, which makes it easy to scale, distributing data across multiple machines and aggregating and summarizing the contents of a column across many rows."
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "What are graph databases optimal for?",
    "description": "Graph databases are optimal for recommendation engines because graphs explore relationships between individual pieces of data."
  },
  {
    "id": 32,
    "topic_id": 1,
    "title": "What data format describes organizing data into a sequence of records where each record has a fixed number of fields?",
    "description": "A linear data format."
  },
  {
    "id": 33,
    "topic_id": 1,
    "title": "Name two examples of linear data format.",
    "description": "Tables in relational databases and comma-separated values (CSV) files."
  },
  {
    "id": 34,
    "topic_id": 1,
    "title": "What does each line of text represent in a CSV file?",
    "description": "A record/tuple/row."
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "Name two examples of non-linear data format.",
    "description": "JSON and XML both represent data in a tree-like structure of nested objects and elements."
  },
  {
    "id": 36,
    "topic_id": 1,
    "title": "Which database type is suited to handling linear data, and which is suited to handling non-linear data?",
    "description": "A relational database is suited to handling linear data, while a NoSQL database is suited to handling nonlinear data."
  },
  {
    "id": 37,
    "topic_id": 1,
    "title": "What is the name of the fully managed key-value database service from AWS?",
    "description": "Amazon DynamoDB available from AWS."
  },
  {
    "id": 38,
    "topic_id": 1,
    "title": "What is the name of a popular document database that is available as a database on servers you manage and as a fully managed service?",
    "description": "MongoDB is available as a database on servers you manage and as a fully managed service named MongoDB Atlas through AWS, Azure, and GCP."
  },
  {
    "id": 39,
    "topic_id": 1,
    "title": "What is the name of a broadly adopted open-source column-oriented distributed database that runs on hardware you manage?",
    "description": "Cassandra."
  },
  {
    "id": 40,
    "topic_id": 1,
    "title": "What is the name of a leading graph database management system that is available as a database on servers you manage and as a fully managed service?",
    "description": "Node4j is available as a database on servers you manage and as a fully managed database service named AuraDB through AWS and GCP."
  },
  {
    "id": 41,
    "topic_id": 1,
    "title": "What is the name of a database product that is well suited for highly interconnected data such as social networks and product recommendations?",
    "description": "Neo4j."
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "What is the name of the hosted multimodel platform database from Microsoft Azure that supports key-value, document, column-oriented, and graph workloads?",
    "description": "Cosmos."
  },
  {
    "id": 43,
    "topic_id": 2,
    "title": "What is the name of the discipline that focuses on how people feel when they interact with a system?",
    "description": "User experience (UX)."
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "What three attributes do UX designers focus on as they strive to improve the customer experience?",
    "description": "Ease of use, efficiency, and usefulness."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "What is the name of the software development approach that can make software more modular, reusable, and scalable?",
    "description": "Object-oriented programming (OOP)."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "What is the name of the technique that allows developers to work with data stored in relational databases using OOP languages?",
    "description": "Object-relational mapping (ORM)."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "What is the function of the ORM framework?",
    "description": "Translating the operations performed on objects into SQL commands."
  },
  {
    "id": 48,
    "topic_id": 1,
    "title": "Which ORM framework provides caching?",
    "description": "Hibernate."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "Which ORM framework supports Language Integrated Query (LINQ)?",
    "description": "Entity Framework."
  },
  {
    "id": 50,
    "topic_id": 1,
    "title": "What kind of code do ORMs generate as part of abstracting the database to the programmer?",
    "description": "SQL code."
  },
  {
    "id": 51,
    "topic_id": 3,
    "title": "What are three types of information that a SQL explain plan or execution plan provides?",
    "description": "Information about the operations performed, the order in which they occur, and the database objects used to store and access data."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "What is the term for the process of automating a series of tasks?",
    "description": "Scripting."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "What are three actions you can perform on a relational database using DDL?",
    "description": "Create, change, and remove database structures, including tables, fields, relationships between tables, indexes, and views."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "What are the four primary operations in DML known as CRUD operations?",
    "description": "Create, read, update, and delete."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "What type of logic can be used in relational databases to retrieve, update, and manipulate data in tables?",
    "description": "Set-based logic."
  },
  {
    "id": 56,
    "topic_id": 1,
    "title": "What are the three primary set operations that allow manipulating data sets?",
    "description": "Finding the union, intersection, and difference of two or more sets."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "The commands BEGIN TRANSACTION, COMMIT, and ROLLBACK are part of which SQL sublanguage?",
    "description": "Transaction Control Language (TCL)."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "What do we call a sequence of one or more SQL statements that need to execute together as a single atomic unit?",
    "description": "A transaction."
  },
  {
    "id": 59,
    "topic_id": 1,
    "title": "Why is transaction length a critical factor when designing transactions in a multiuser environment?",
    "description": "Because transactions lock tables on which they operate, and changes made are not visible to users until a commit or rollback ends the transaction."
  },
  {
    "id": 60,
    "topic_id": 4,
    "title": "What is the name of the principle that ensures data safety, consistency, and reliability?",
    "description": "The ACID principle."
  },
  {
    "id": 61,
    "topic_id": 2,
    "title": "What does ACID stand for?",
    "description": "Atomicity, consistency, isolation, and durability."
  },
  {
    "id": 62,
    "topic_id": 2,
    "title": "Ensuring the uniqueness of primary key is an example of which ACID principle?",
    "description": "Consistency."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "Which ACID principle ensures that changes made by one transaction are not visible to other transactions until the current transaction either commits or rolls back?",
    "description": "Isolation."
  },
  {
    "id": 64,
    "topic_id": 1,
    "title": "What is a great benefit of using ANSI SQL?",
    "description": "ANSI SQL is portable across different relational database management system platforms."
  },
  {
    "id": 65,
    "topic_id": 1,
    "title": "Which two functions does programming with SQL allow you to perform?",
    "description": "Bulk administrative tasks and encapsulating business logic."
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "What database object executes SQL automatically every time the underlying data changes before or after a pending data change, such as inserting, updating, or deleting data in a table, takes place?",
    "description": "A trigger."
  },
  {
    "id": 67,
    "topic_id": 1,
    "title": "What term describes a database object that contains a pre-compiled subroutine stored within a SQL database?",
    "description": "Stored procedure."
  },
  {
    "id": 68,
    "topic_id": 1,
    "title": "What makes stored procedures an attractive option for implementing business logic within a relational database?",
    "description": "Flow control and set-based operations included in programmatic SQL."
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "What term describes a pre-compiled set of SQL statements that returns a single value after performing a specific task or computation?",
    "description": "A function."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "Inside which SQL statement and SQL clause can a SQL function be used?",
    "description": "A SQL function can be used inside a SELECT statement and a WHERE clause."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "What are four examples of aggregation functions in SQL?",
    "description": "COUNT, SUM, MIN, MAX, and AVG."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "What term describes a read-only result set of a SELECT statement as a virtual table?",
    "description": "A view."
  },
  {
    "id": 73,
    "topic_id": 4,
    "title": "What is accomplished by suppressing sensitive information using a view in SQL?",
    "description": "Enforcing data access restrictions and improving data security."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "What is the difference between a view and a materialized view in a SQL?",
    "description": "A view is executed before a query and contains any changes to the underlying table, while a materialized view stores the result of a query in a static physical table improving query performance while introducing a data freshness issue which can be addressed through automatic refreshes."
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "What is the primary objective of monitoring and reporting in the realm of database management?",
    "description": "The primary objective of monitoring and reporting is to maintain a consistent, high-quality user experience by ensuring the database performs well, is reliable, and is secure."
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What is vital to monitoring resource utilization?",
    "description": "Collecting data from the operating system and the database is vital to monitoring resource utilization."
  },
  {
    "id": 77,
    "topic_id": 3,
    "title": "How can a data systems analyst use data gathered from the operating system and database?",
    "description": "A data systems analysts can use data gathered from the operating system and database to proactively resolve issues, optimize performance, forecast future resource requirements, and validate database security."
  },
  {
    "id": 78,
    "topic_id": 3,
    "title": "What is crucial for improving reliability of a database?",
    "description": "Early detection and resolution of potential problems are crucial for improving database reliability."
  },
  {
    "id": 79,
    "topic_id": 3,
    "title": "How do usage trends help analysts?",
    "description": "Analysts can use usage trends to make informed decisions regarding infrastructure upgrades and resource allocation, improving capacity planning capabilities."
  },
  {
    "id": 80,
    "topic_id": 3,
    "title": "What does the strategy management by exception focus on?",
    "description": "Management by exception focuses on identifying and addressing deviations from expected behavior."
  },
  {
    "id": 81,
    "topic_id": 3,
    "title": "What are system alerts?",
    "description": "System alerts are automated messages which notify administrators that action is required to keep a database operationally stable."
  },
  {
    "id": 82,
    "topic_id": 3,
    "title": "What is measured by capacity utilization?",
    "description": "Capacity utilization measures the percentage of total storage space currently in use."
  },
  {
    "id": 83,
    "topic_id": 3,
    "title": "How does tracking data growth rate help administrators?",
    "description": "Tracking data growth rate helps administrators manage existing storage resources and plan capacity upgrades."
  },
  {
    "id": 84,
    "topic_id": 3,
    "title": "What does storage tiering track?",
    "description": "Storage tiering tracks database file distribution across storage tiers based on performance needs and access frequency."
  },
  {
    "id": 85,
    "topic_id": 3,
    "title": "What is included in standard daily usage metrics?",
    "description": "Standard daily usage metrics includes active users, concurrent connections, error rates, and user activity patterns."
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "What are two essential throughput metrics?",
    "description": "Essential throughput metrics include average query repones time and transfer volume."
  },
  {
    "id": 87,
    "topic_id": 3,
    "title": "What term describes a system\u2019s resources being fully utilized to the point that they can no longer handle additional workloads?",
    "description": "Resource saturation occurs when a system\u2019s resources are fully utilized and can no longer handle additional workloads."
  },
  {
    "id": 88,
    "topic_id": 3,
    "title": "What is vital to determining whether current resource utilization is typical or if something unexpected is happening?",
    "description": "To determine whether current resource utilization is typical or if something unexpected is happening, you need a resource utilization baseline."
  },
  {
    "id": 89,
    "topic_id": 3,
    "title": "In what ways does a resource utilization baseline help?",
    "description": "A resource utilization baseline can help determine if resource utilization is atypical, provide a reference point for comparing system performance, plan for future resource needs, and help understand and measure the impact of a change."
  },
  {
    "id": 90,
    "topic_id": 5,
    "title": "What is a common tactic to improve database availability in the event of a failure?",
    "description": "Replication is a common tactic to improve database availability in the event of a failure."
  },
  {
    "id": 91,
    "topic_id": 5,
    "title": "What is an integral component of a comprehensive data protection strategy?",
    "description": "Database backups are integral components of a comprehensive data protection strategy."
  },
  {
    "id": 92,
    "topic_id": 3,
    "title": "Which two primary log categories contain detailed information vital to understanding a database\u2019s stability and performance?",
    "description": "Transaction logs and system logs are two primary categories of detailed information vital to understanding a database\u2019s stability and performance."
  },
  {
    "id": 93,
    "topic_id": 5,
    "title": "What is the name of the log that contains a chronological record of all changes made to the data in a database?",
    "description": "Transactions logs are chronological records of all changes made to the data in a database."
  },
  {
    "id": 94,
    "topic_id": 4,
    "title": "Which log is helpful when you need to audit changes in the database?",
    "description": "Transaction logs are helpful when you need to audit changes in the database."
  },
  {
    "id": 95,
    "topic_id": 3,
    "title": "Which events and actions are stored in system logs on a server?",
    "description": "Events and actions stored in system logs on a server include system warnings and errors, software and operating system versions, successful and attempted user logins, and system resource utilization data."
  },
  {
    "id": 96,
    "topic_id": 3,
    "title": "What is a viable way of ensuring the efficiency of bulk data loads?",
    "description": "A viable way of ensuring the efficiency of bulk data loads is disabling transaction logging."
  },
  {
    "id": 97,
    "topic_id": 3,
    "title": "What term describes a circular standoff where two or more transactions lock a resource the other needs and block each other indefinitely?",
    "description": "A deadlock describes a circular standoff where two or more transactions lock a resource the other needs and thus block each other indefinitely."
  },
  {
    "id": 98,
    "topic_id": 2,
    "title": "What is the function of domain integrity check?",
    "description": "Domain integrity validates that column values conform to business rules and column definitions."
  },
  {
    "id": 99,
    "topic_id": 3,
    "title": "What is the difference between shared locks and exclusive locks?",
    "description": "Shared locks apply to read operations while exclusive locks apply when a transaction inserts, updates, or deletes data."
  },
  {
    "id": 100,
    "topic_id": 4,
    "title": "What do audit logs contain?",
    "description": "Audit logs contain a record of who accessed the database, what they accessed, where they accessed it from, and when the access happened."
  },
  {
    "id": 101,
    "topic_id": 3,
    "title": "What can improve query performance and reduce the time it takes to retrieve data from a database?",
    "description": "Indexes can improve query performance and reduce the time it takes to retrieve data from a database."
  },
  {
    "id": 102,
    "topic_id": 3,
    "title": "What is the function of load balancing?",
    "description": "Load balancing distributes client requests across a set of servers which enhances database availability and improves performance."
  },
  {
    "id": 103,
    "topic_id": 3,
    "title": "What is the difference between Round Robin, Least Connections, and Resource-Based load balancer algorithms?",
    "description": "The Round Robin approach routes incoming requests evenly across the available database notes in sequential order; the Least Connections approach directs incoming queries to the server with the fewest active connections; and Resource-Based approach distributes queries based on the database servers\u2019 current resource utilization."
  },
  {
    "id": 104,
    "topic_id": 2,
    "title": "What does change management include?",
    "description": "Change management includes planning, implementing, and managing change to minimize disruption while maximizing reliability and acceptance of the change."
  },
  {
    "id": 105,
    "topic_id": 4,
    "title": "What is the change advisory board\u2019s primary responsibility?",
    "description": "The primary responsibility of the change advisory board is to assess the impacts of proposed changes."
  },
  {
    "id": 106,
    "topic_id": 2,
    "title": "What is the use of a database refresh?",
    "description": "A database refresh lets you replicate production issues, test new features, and analyze data in a nonproduction environment by refreshing development and test environments with a production database."
  },
  {
    "id": 107,
    "topic_id": 3,
    "title": "What are standard operating procedures (SOPs)?",
    "description": "SOPs are step-by-step instructions detailing how to perform routine database maintenance tasks. SOPs can also cover system architecture, data backup and restoration, security management, data quality, maintenance, performance tuning, troubleshooting, disaster recovery plan, incident response planning, change management, and system updates/upgrades, among others."
  },
  {
    "id": 108,
    "topic_id": 2,
    "title": "Which term refers to having duplicate data within the database?",
    "description": "Data redundancy refers to having duplicate data within the database and can happen during mergers and acquisitions, among other reasons."
  },
  {
    "id": 109,
    "topic_id": 4,
    "title": "What three functions are covered under data governance?",
    "description": "Creation, interpretation, and enforcement of data use."
  },
  {
    "id": 110,
    "topic_id": 4,
    "title": "What data governance term describes the act of developing the policies and procedures for looking after an organization\u2019s data quality, security, privacy, and regulatory compliance?",
    "description": "Data stewardship."
  },
  {
    "id": 111,
    "topic_id": 4,
    "title": "What data governance term describes the senior business leader with overall responsibility for a specific data domain?",
    "description": "Data owner."
  },
  {
    "id": 112,
    "topic_id": 4,
    "title": "With whom does a data owner work to establish policies and procedures for their data domain?",
    "description": "Data steward."
  },
  {
    "id": 113,
    "topic_id": 4,
    "title": "What role implements data governance policies through technical controls, configuring applications, dashboards, and databases?",
    "description": "Data custodian."
  },
  {
    "id": 114,
    "topic_id": 4,
    "title": "What does a data classification matrix contain?",
    "description": "Categories, descriptions, and disclosure implications for data."
  },
  {
    "id": 115,
    "topic_id": 4,
    "title": "What term describes the practice of granting individuals data access permissions based on the role they occupy, facilitating permissions, maintenance, and compliance audits while improving consistency?",
    "description": "Role-based access."
  },
  {
    "id": 116,
    "topic_id": 4,
    "title": "What principle states that an individual should only have the minimum set of privileges necessary to complete their assigned job duties, minimizing insider attacker damage and limiting external attacker privilege escalation routes?",
    "description": "The principle of least privilege."
  },
  {
    "id": 117,
    "topic_id": 4,
    "title": "Describe two types of guidance provided concerning the end-of-life process for information under data retention policies.",
    "description": "A minimum and maximum retention period for data elements to limit an organization\u2019s risk exposure and proper disposal of data due to data remanence issues."
  },
  {
    "id": 118,
    "topic_id": 4,
    "title": "What is the role of IAM programs?",
    "description": "Identity and access management programs seek to ensure that only authorized individuals gain access to information systems and databases in an organization."
  },
  {
    "id": 119,
    "topic_id": 4,
    "title": "When users request access to resources, what three processes do they proceed through?",
    "description": "Identification, where users claim their identity; authentication, where users prove their identity to an access control system; and authorization, where access control lists itemize the specific filesystem permissions granted to individual users or groups of users."
  },
  {
    "id": 120,
    "topic_id": 4,
    "title": "What term describes the process of removing identifiers that can compromise individual privacy?",
    "description": "De-identifying data."
  },
  {
    "id": 121,
    "topic_id": 4,
    "title": "What is the name of the technology that helps an organization enforce information handling policies and procedures to prevent data loss and theft?",
    "description": "Data loss prevention (DLP)."
  },
  {
    "id": 122,
    "topic_id": 4,
    "title": "What term describes the application of digital tags to sensitive documents so that they may be monitored by the DLP systems for content containing those tags?",
    "description": "Watermarking."
  },
  {
    "id": 123,
    "topic_id": 4,
    "title": "What is the name of the process of analyzing data and organizing it into risk-based categories?",
    "description": "Data classification."
  },
  {
    "id": 124,
    "topic_id": 4,
    "title": "What HIPAA rule provision identifies 18 data elements as PHI?",
    "description": "Privacy rule."
  },
  {
    "id": 125,
    "topic_id": 4,
    "title": "What HIPAA provision applies solely to e-PHI data to ensure the confidentiality, integrity, and availability of e-PHI data through limiting access to authorized parties with systems and processes in place to prevent unauthorized access or accidental disclosure?",
    "description": "Security Rule."
  },
  {
    "id": 126,
    "topic_id": 4,
    "title": "What term describes organizations legally obligated under HIPAA to protect the privacy and security of PHI?",
    "description": "Covered entity."
  },
  {
    "id": 127,
    "topic_id": 4,
    "title": "What regulation ensures the security of cardholder financial transactions?",
    "description": "PCI DSS."
  },
  {
    "id": 128,
    "topic_id": 4,
    "title": "What European law has the purpose of giving individuals control over how their personal data is collected, stored, and used?",
    "description": "The General Data Protection Regulation (GDPR)."
  },
  {
    "id": 129,
    "topic_id": 4,
    "title": "What term describes a web application exploit that sends unauthorized commands to a backend database server?",
    "description": "SQL injection attack."
  },
  {
    "id": 130,
    "topic_id": 4,
    "title": "What term describes attacks that make a system or resource unavailable to legitimate users by sending thousands of requests to a network, server, or application, overwhelming it and making it unable to answer any requests?",
    "description": "Denial of Service (DoS)."
  },
  {
    "id": 131,
    "topic_id": 4,
    "title": "What attack has occurred when an attacker causes traffic that should be sent to its intended recipient to be relayed through a system or device the attacker controls?",
    "description": "On-path attack."
  },
  {
    "id": 132,
    "topic_id": 4,
    "title": "What attack iterates through passwords until one that works is found?",
    "description": "A brute-force attack."
  },
  {
    "id": 133,
    "topic_id": 5,
    "title": "What term describes the amount of time in which a function can be feasibly recovered in the event of a disruption?",
    "description": "Recovery time objective (RTO)."
  },
  {
    "id": 134,
    "topic_id": 5,
    "title": "What term describes the point in time before the incident where the organization should be able to recover data from a critical business process?",
    "description": "Recovery point objective (RPO)."
  },
  {
    "id": 135,
    "topic_id": 3,
    "title": "What term describes a documentation providing step-by-step instructions for configuring and deploying critical systems, including software, hardware, and network components?",
    "description": "Build documentation."
  },
  {
    "id": 136,
    "topic_id": 5,
    "title": "What term describes the act of moving database backups to a remote site using bulk transfers?",
    "description": "Database dumping."
  },
  {
    "id": 137,
    "topic_id": 5,
    "title": "What term describes data transfers of database transaction logs that are performed in a more expeditious manner, occurring on a more frequent basis?",
    "description": "Log shipping."
  },
  {
    "id": 138,
    "topic_id": 5,
    "title": "What term describes a live database server that is maintained at the backup site with real-time current data with the remote server receiving copies of the database modifications at the same time they are applied to the production server at the primary site?",
    "description": "Remote mirroring."
  },
  {
    "id": 139,
    "topic_id": 5,
    "title": "What term describes a backup that is performed only on those files that have been modified since the time of the most recent full or incremental backup?",
    "description": "Incremental backup."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Describe the difference between relational and nonrelational databases.",
    "description": "Relational and nonrelational, or NoSQL, are two different types of databases used to store and manage data. Relational databases use a structured data model, which organizes data into tables with rows and columns. Nonrelational databases use a variety of data models, including key-value, document, column-oriented, and graph. With relational databases, you need to define data structures before using the database. Nonrelational databases often have a more flexible data structure, allowing them to store data in various formats. From an operational standpoint, nonrelational databases are easier to scale than their relational counterparts."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Describe the difference between linear and nonlinear data.",
    "description": "Linear and nonlinear data formats are two different ways of organizing and storing data. Linear data formats are relatively straightforward to work with, given that the data is in a linear, sequential format. A CSV file is an example of a linear data format. Since relational databases are highly structured, they are well-suited to storing linear data."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Describe common NoSQL database categories.",
    "description": "Key-value, document databases, column-oriented, and graph are four categories of NoSQL databases that store and manage data differently. Key-value databases store data in key-value pairs and are ideal for storing audio, image, and video data. Document databases are similar to key-value, restricting the values in a known, JSON-like document format. Column-oriented databases store data in columns rather than rows, making them suitable for the aggregations associated with data warehousing and business intelligence applications. Graph databases store data in nodes and edges, representing the entities and relationships in a data set. Graph use cases include real-time recommendation engines, fraud detection, and identity and access management."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Describe object-relational mapping.",
    "description": "Object-relational mapping is a technique that allows developers to work with databases using object-oriented programming languages rather than writing SQL statements. Available for many object-oriented programming languages, ORM frameworks provide a layer of abstraction between a relational database and an application, allowing developers to work with objects in their code. Meanwhile, the ORM handles the translation of these objects into SQL statements."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Describe the impact of using an object-relational mapping framework.",
    "description": "To gauge the impact of using an object-relational mapping framework, you first need to decide how to assess the ORM's impact. You need to select a performance measure, such as response time, throughput, or resource utilization, as the basis for comparison. You can then compare database performance between the ORM's SQL and the SQL a human writes. If you have multiple applications using the same database, be sure to include the effect of the ORM's caching layer in your evaluation, as stale data in the cache can cause inconsistent application behavior. You can also incorporate other factors, including code maintainability, in your assessment. If you determine the ORM is having an outsized impact on performance, you decide whether it is viable to evaluate a different ORM framework or use human-generated SQL."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Describe the difference between DML and DDL.",
    "description": "Data Definition Language creates, modifies, and removes database objects, including tables, views, and indexes. Data Manipulation Language creates, reads, updates, and deletes data. With a few exceptions, like dropping a table, DDL statements do not change data within the database. You use DML statements to interact with data, while you use DDL when you need to alter the structure of the database."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Describe the importance of set-based logic.",
    "description": "Set-based logic manipulates sets of data as a whole rather than as individual records. This approach is vital in database development and management because it is typically more efficient and scalable than a procedural approach. Manifesting the set principles of intersection, union, and difference, SQL implements set-based logic, allowing administrators and developers to create fast, concise, and maintainable code."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Describe the importance of transaction control languages.",
    "description": "TCLs represent a framework for incorporating one or more SQL statements into a single unit of work. If any subcomponent of a transaction fails, the entire transaction fails, reverting any changes made during the transaction. A commit statement saves and ends a transaction, while a rollback undoes any work and ends the transaction."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Describe the ACID principles.",
    "description": "ACID refers to Atomicity, Consistency, Isolation, and Durability. TCLs enable atomicity by letting you treat more than one SQL statement as a single unit of work. A primary key constraint enforces consistency by ensuring that every value for the primary key is unique. Isolation keeps transactions separate from one another, allowing simultaneous concurrent transactions without corrupting the data. Durability ensures data safety, so data is not lost during a database crash or hardware failure."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Describe the importance of scripting and runtime location.",
    "description": "Scripting is essential for efficient database operations. Scripting lets you programmatically maintain, patch, upgrade, back up, and restore databases. Server-side scripts run on the database server, while client-side scripts run on a network-adjacent server. Long-running scripts that rely on a persistent database connection are usually server-side, while client-side activity tends to be shorter in duration and less crucial to database operations."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Distinguish between IaaS, PaaS, and SaaS.",
    "description": "IaaS provides virtualized computing resources over the Internet. Users manage the infrastructure while the provider maintains the physical hardware, making IaaS similar to an on-premises environment. With PaaS, the provider also operates the database software. In a SaaS environment, the end user lacks visibility into the hardware, database, or application software."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Describe data cardinality.",
    "description": "Data cardinality represents the relationship between two tables, indicating the number of rows in one table that relate to rows in another table. ERDs illustrate cardinality with different line terminators. These terminators can show if the relationship between tables is optional or required and whether a row in the first table refers to one or more than one row in the related table."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Describe referential integrity.",
    "description": "Referential integrity is a fundamental concept that improves data quality by ensuring that data is consistent and accurate across tables in relational databases. Referential integrity uses primary and foreign keys to enforce these relationships. A design must comply with the Insert Rule, the Update Rule, the Delete Rule, and the Foreign Key rule to achieve referential integrity."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Explain why databases should be a private network.",
    "description": "By isolating a database in a private network, you can restrict access to specific users and applications, minimizing the risk of data breaches. Having the database in a private network also enables organizations to implement additional security measures, with firewalls and intrusion-detection systems furthering safeguarding the database."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Explain the importance of stress testing.",
    "description": "Stress testing a database is essential for ensuring its performance, reliability, and stability under heavy workloads. Stress testing helps identify bottlenecks, optimize resource allocation, and validate system resilience during peak workload conditions."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Explain the difference between resource utilization and saturation.",
    "description": "Resource utilization measures the current usage level of resources such as CPU, memory, storage, and network bandwidth. Saturation is a state of maximum utilization where the resource can no longer handle additional work. A data systems analyst should maximize utilization while avoiding saturation."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Describe why establishing baseline performance data is crucial to database operations.",
    "description": "Establishing baseline performance data creates a reference point for database behavior. Using this reference point, a data systems analyst can identify deviations, optimize resources, and inform future capacity needs."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Describe the query optimization process.",
    "description": "The first step in the query optimization process is identifying poorly performing queries. After determining the query's purpose and impact on system resources, analyze the execution plan to understand the query's road map. Examine the execution plan for resource-consuming activities such as full table scans or subselects, and resolve the issues by rewriting the query, adjusting indexes, ensuring the use of bind variables, and adjusting other database parameters as necessary. After verifying that your change resolves the issue, use your established change management process to propagate the modified code/configuration settings into production."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Explain common database SOPs.",
    "description": "SOPs are detailed step-by-step instructions for routine database maintenance tasks. They ensure stability, operational consistency, and compliance obligations. SOPs have a broad scope, covering system architecture, data backup and restoration, security management, data quality, maintenance and performance tuning, troubleshooting, disaster recovery, incident response, change management, and system updates and upgrades. Regularly updating and communicating SOPs is essential to reflect changes in the database system or organizational policies. SOPs provide a reference for operational duties and aid in maintaining a stable and compliant database environment."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Explain the difference between data redundancy and data sharing.",
    "description": "Data redundancy refers to duplicate data within a database, leading to storage inefficiency and potential inconsistencies. Data sharing enables multiple users to access and manipulate the same data simultaneously. Having redundant data increases the risk of data duplication, while data sharing reduces that risk."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Understand the use of encryption to protect sensitive information.",
    "description": "Encryption is the process of encoding data with a key so that only authorized parties can read it. Once encrypted, you can only access the data by decrypting it with a valid key. If you lose the encryption key, any data encrypted with that key becomes useless. To keep data secure, you must encrypt data at rest as well as data in transit. Data at rest is data that exists in permanent storage. Data in transit is data that is beign sent over a network."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Describe the four types of audits performed by data systems professionals.",
    "description": "Expired account audits focus on monitoring and revoking unused credentials and ensuring accurate permissions. Connection request audits monitor for unusual activity and unauthorized use of permissions through continuous account monitoring systems. SQL code audits ensure the proper design, permissioning, and functionality of SQL code. Credential storage checks monitor for the safe storage of passwords and secrets to avoid exposure."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Explain the purpose of governance and regulatory compliance.",
    "description": "Data systems professionals must ensure that their organization's information handling practices comply with local, national, and global laws and regulations. Personally identifiable information (PII) includes any information that uniquely identifies an individual person. PII is regulated by the GDPR in the European Union. Personal health information (PHI) includes medical records regulated by HIPAA in the United States. Credit and debit card data is regulated globally by PCI DSS."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Explain the major components of an identity and access management program.",
    "description": "Identity and access management systems perform three major functions: identification, authentication, and authorization. Identification is the process of a user making a claim of identity, such as by providing a username. Authentication allows the user to prove their identity. Authentication may be done using something you know, something you have, or something you are. Multifactor authentication combines different authentication techniques to provide stronger security. Authorization ensures that authenticated users may only perform actions necessary to carry out their assigned responsibilities."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Know that physical security controls are a first line of defense.",
    "description": "Keeping your site secure involves techniques like using industrial camouflage as well as security controls like fences, lighting, alarms, signage, bollards, mantraps, cameras, and other sensors. Ensuring that only permitted staff are allowed in using locks, badges, and guards helps prevent unauthorized visitors. Fire suppression and other environment controls keep systems and devices safe from risks caused by natural or human disasters like fires, floods, or other issues."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Explain how logical security controls protect data systems.",
    "description": "Firewalls serve as the first line of defense for networked systems, preventing unauthorized connections to databases and other secure servers. Firewalls create a perimeter network and protect everything inside that perimeter from attack. Network engineers may also use port security controls to limit the systems that may physically connect to switches on the internal network."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Describe how injection vulnerabilities allow attackers to interact with backend systems.",
    "description": "SQL injection vulnerabilities are the most common example, allowing an attacker to exploit a dynamic web application to gain access to the underlying database. The best defense against injection vulnerabilities is to perform rigorous input validation on any user-supplied input."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Understand the concepts of DoS and DDoS Attacks.",
    "description": "DoS attacks target the availability aspect of the CIA triad and aim to make a system or resource unavailable to legitimate users by overwhelming it with numerous requests. Unlike other types of attacks, DoS attacks focus on disrupting the legitimate use of a system. However, the drawback of basic DoS attacks is that they require a large amount of bandwidth and can easily be blocked. DDoS attacks overcome these limitations by using botnets to overwhelm the target, making it difficult to distinguish attack requests from legitimate requests. DDoS attacks pose a serious threat to system administrators, and defending against them requires understanding the attack techniques and implementing blocking technology to identify and weed out suspected attack traffic."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Understand the concept of on-path attacks and their variants.",
    "description": "An on-path attack is a type of attack where an attacker causes traffic that should be sent to its intended recipient to be redirected through a system or device under their control. This enables the attacker to eavesdrop or modify the communications. One of the most well-known on-path attack variants is the SSL stripping attack, in which an attacker removes the TLS encryption from communications to read the contents. Another on-path attack variant is the man-in-the-browser (MitB) attack, in which malware inserted in a user's browser is used to access and modify information sent and received by the browser."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "Describe the different types of malware and how they work to undermine the security of systems.",
    "description": "Viruses are malicious code objects that spread from one system to another and carry out the intentions of the attacker, such as stealing data or disrupting system activity. Trojan horses appear to be legitimate software but also carry a hidden malicious payload that performs unwanted actions. Rootkits target the special super-user account on a system to gain unrestricted access to system resources. Spyware gathers information without the user's knowledge and reports it back to the attacker for purposes such as identity theft or espionage. Ransomware uses encryption to block access to a system or data until a ransom is paid."
  },
  {
    "id": 170,
    "topic_id": 200,
    "title": "Understand the risk posed to data systems security by phishing attacks and their variants.",
    "description": "Phishing attacks target sensitive information like passwords, usernames, or credit card information by tricking the targeted individual into believing that the message they received is true and real. There are various forms of phishing such as vishing (voice phishing via the phone system), smishing (phishing via SMS messages), whaling (aimed at high-profile individuals in an organization), and spearphishing (aimed at specific individuals)."
  },
  {
    "id": 171,
    "topic_id": 200,
    "title": "Describe the common elements of disaster recovery plan documentation.",
    "description": "The disaster recovery plan should be documented in a detailed manual that provides sufficient detail to support the efforts of team members during a disaster. It should also include related documentation, such as the system security plan, continuity of operations plan, and build documentation."
  },
  {
    "id": 172,
    "topic_id": 200,
    "title": "Explain the different technologies used to provide high availability and fault tolerance.",
    "description": "Fault tolerance is achieved by adding redundant components, such as additional disks, within a properly configured redundant array of inexpensive disks (RAID) array or additional servers within a failover clustered configuration. High availability is often achieved through the use of load balancing and failover servers."
  },
  {
    "id": 173,
    "topic_id": 200,
    "title": "Explain the different technologies used to support disaster recovery plans.",
    "description": "Database dumping moves backups of the database to a remote site in a bulk transfer operation. Log shipping provides more frequent updates, moving only changed data stored in transaction logs. Database mirroring uses real-time updates to maintain a live copy of the production database at a remote location."
  },
  {
    "id": 174,
    "topic_id": 200,
    "title": "Understand the concepts of MTD, RTO, and RPO.",
    "description": "The maximum tolerable downtime is the maximum length of time a business function can tolerate a disruption before suffering irreparable harm. The recovery time objective for each business function is the amount of time in which you think you can feasibly recover the function in the event of a disruption. Ensure that your RTOs are less than your MTDs, resulting in a situation in which a function should never be unavailable beyond the maximum tolerable downtime. The recovery point objective defines the point in time before the incident where the organization should be able to recover data from a critical business process."
  },
  {
    "id": 175,
    "topic_id": 200,
    "title": "Explain the different types of backups.",
    "description": "Full backups store a complete copy of the data contained on the protected device. Incremental backups store only those files that have been modified since the time of the most recent full or incremental backup. Differential backups store all files that have been modified since the time of the most recent full backup."
  },
  {
    "id": 176,
    "topic_id": 200,
    "title": "Know the five types of disaster recovery plan tests and the impact each has on normal business operations.",
    "description": "The five types of disaster recovery plan tests are read-through tests, structured walk-throughs, simulation tests, parallel tests, and full-interruption tests. Checklist tests are purely paperwork exercises, whereas structured walk-throughs involve a project team meeting. Neither has an impact on business operations. Simulation tests may shut down noncritical business units. Parallel tests involve relocating personnel but do not affect day-to-day operations. Full-interruption tests involve shutting down primary systems and shifting responsibility to the recovery facility."
  }
];
